/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { isRightToLeft } from 'js/lib/language';

import { Typography2, breakpoints } from '@coursera/cds-core';

import CoachButton from 'bundles/unified-description-page-common/components/coach/CoachButton';

import _t from 'i18n!nls/xdp';

const styles = {
  coachButtonContainer: ({ isRTL = false }: { isRTL?: boolean }) => css`
    display: inline-flex;
    gap: var(--cds-spacing-200);
    background: ${isRTL
      ? 'linear-gradient(90deg, rgb(15 240 255 / 10%) 0%, rgb(66 133 244 / 40%) 100%)'
      : 'linear-gradient(90deg, rgb(66 133 244 / 40%) 0%, rgb(15 240 255 / 10%) 100%)'};
    border-radius: var(--cds-border-radius-max);
    padding-top: var(--cds-spacing-50);
    padding-bottom: var(--cds-spacing-50);
    padding-left: var(--cds-spacing-50);
    padding-right: var(--cds-spacing-200);
    align-items: center;
    justify-content: start;

    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-100);
      margin-bottom: var(--cds-spacing-300);
    }

    ${breakpoints.down('xs')} {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: var(--cds-spacing-100);
      border-radius: var(--cds-border-radius-200);
      padding: var(--cds-spacing-100) var(--cds-spacing-150);
      background: linear-gradient(180deg, rgb(66 133 244 / 40%) 0%, rgb(15 240 255 / 10%) 100%);
    }
  `,
  coachButton: css`
    .cds-button-label {
      white-space: nowrap;
    }
  `,
  coachButtonDescription: css`
    font-weight: 500;
  `,
};

const CoachButtonBelowKeyInformation = () => {
  const isRTL = isRightToLeft(_t.getLocale());

  return (
    <div css={styles.coachButtonContainer({ isRTL })}>
      <CoachButton css={styles.coachButton} />
      <Typography2 component="p" variant="bodySecondary" css={styles.coachButtonDescription}>
        {_t('Ask Coursera to see how this certificate aligns with your career path.')}
      </Typography2>
    </div>
  );
};

export default CoachButtonBelowKeyInformation;
